import { defineComponent, h, useAttrs } from 'vue'
import { VRow } from 'vuetify/components'
import { hasBooleanishAttr } from './legacyInputProps'

export function normalizeRowAttrs(attrs) {
  const normalized = { ...attrs }

  if (hasBooleanishAttr(attrs.dense) && normalized.density == null) {
    normalized.density = 'compact'
    normalized.class = [attrs.class, 'v-row--legacy-dense']
  }

  delete normalized.dense

  return normalized
}

export default defineComponent({
  name: 'VRowCompat',
  compatConfig: {
    RENDER_FUNCTION: false,
    COMPONENT_V_MODEL: false,
    INSTANCE_ATTRS_CLASS_STYLE: false
  },
  inheritAttrs: false,

  setup(_, { slots }) {
    const attrs = useAttrs()

    return () => h(VRow, normalizeRowAttrs(attrs), slots)
  }
})
